import React from 'react';
import { useTheme } from '@mui/styles';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';

import Typography from '@mui/material/Typography';
import { FormattedMessage, useIntl } from 'react-intl';
import { Legend } from '../Common/Legend';

const useStyles = makeStyles((theme) => ({
  chartContainer: {
    height: '10vh',
    backgroundColor: theme.palette.insights.noData,
    borderRadius: theme.spacing(0),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(2)
  },
  legendContainer: {
    marginTop: theme.spacing(1.5),
    marginLeft: theme.spacing(-1)
  }
}));

const BubbleChartNoData: React.FC = () => {
  const classes = useStyles();
  const theme = useTheme();
  const { formatMessage } = useIntl();
  return (
    <Grid container data-testid="keyword_cloud_no_data">
      <>
        <Grid
          container
          item
          xs={12}
          className={classes.legendContainer}
          justifyContent="flex-end"
        >
          {[1, 2, 3].map((i) => (
            <Legend
              key={i}
              color={theme.palette.insights.noData}
              label={formatMessage({ id: 'insights.timeSheetLabels.na' })}
              borderColor={theme.palette.insights.noData}
              borderStyle="soild"
              labelColor={theme.palette.insights.noData}
            />
          ))}
        </Grid>
        <Grid
          container
          item
          className={classes.chartContainer}
          data-testid={'keyword_cloud_noData_text'}
        >
          <Typography variant="body2">
            <FormattedMessage id={'insights.keywordCloud.noDataMessage'} />
          </Typography>
        </Grid>
      </>
    </Grid>
  );
};

export default React.memo(BubbleChartNoData);
